<template>
  <div class="base">
    <div
      v-for="(item,index) in list"
      :key="index">
      <div
        :class="index!=0?'item-margin-top':''"
        class="item clear "
        @click="byCard(item)">
        <div class="card-img">
          <img
            :src="item.cardImg"
            class="ljb-size100">
        </div>
        <div class="card-item ljb-flex-column">
          <div class="card-title ljb-flex-row"><div
            v-show="item.discountIntro"
            class="card-tag"><span>{{ item.discountIntro }}</span></div>{{ item.productName + (fieldMap[item.productName] ? '(' + fieldMap[item.productName] + ')' : '') }}</div>
          <p class="text">{{ item.productIntro || item.text }}</p>
          <div class="ljb-flex-row align-center-justify-space"> <div><p class="card-price">{{ item.discountPrice?item.discountPrice:item.salePrice }}元<span
            v-show="item.discountPrice"
            class="card-sp">{{ item.salePrice }}元</span></p></div> <div class="btn double-center"><span>立即购买</span></div> </div>
        </div>
      </div>
      <div class="line"/>
    </div>
  </div>
</template>
<script>
import SwipeActive from '../swiper/SwipeActive'
import TimeCard from './TimeCard'
import {mapGetters} from 'vuex'
import ModuleTitle from '@/components/title/ModuleTitle'

const fieldMap = {
  '守住财神': '债权债务',
  '好心分手': '婚姻继承',
  '职场达人': '劳动人事',
  '买房装修': '房产物业',
  '出入平安': '交通出行',
  '宝贝计划': '儿童权益',
  '医患无忧': '医疗纠纷',
  '一脉相承': '婚姻继承',
}

export default {
  name: 'ProductList',
  components: {TimeCard, SwipeActive, ModuleTitle},
  props: {
    list: {
      type: Array,
      default: () => []
    },
    startMargin: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fieldMap,
      // list: [{
      //   img: 'https://cdn.51ljb.cn/ljb-card_pa_gold.png',
      //   name: 'VIP私家律师金卡',
      //   text: '0.3元/天、电话咨询不限次、见面咨询七折',
      //   price: '120',
      //   originalPrice: '1000',
      //   tag: '12.12',
      //   url: 'go_MemberCard/MC19001'
      // }, {
      //   img: 'https://cdn.51ljb.cn/ljb-card_pa_platinum.png',
      //   name: 'VIP私家律师白金卡',
      //   text: '文书审查、发律师函、代打官司',
      //   price: '3000',
      //   originalPrice: '3000',
      //   url: 'go_MemberCard/MC19002'
      // }, {
      //   img: 'https://cdn.51ljb.cn/ljb-card_pa_single.png',
      //   name: '律师咨询次卡',
      //   text: '法律问题按次电话咨询、不限时长',
      //   price: '49',
      //   originalPrice: '80',
      //   url: 'go_TimesCard/PC15001'
      // }, {
      //   img: 'https://cdn.51ljb.cn/ljb-card_pa_timcard.png',
      //   name: '律师咨询时长卡',
      //   text: '抵扣咨询时长',
      //   price: '38',
      //   originalPrice: '60',
      //   url: 'go_TimeCard'
      // }
      // ]
    }
  },
  computed: {
    ...mapGetters('Channel', [
      'getChannelData'
    ]),
    banners () {
      if (this.getChannelData && this.getChannelData.banners) {
        let banners = this.getChannelData.banners.filter((item) => {
          if (item.bannerPlace === this.$dataResource.bannerType.header || item.bannerPlace === this.$dataResource.bannerType.header + '') return false
        })
        if (banners.length < 1) {
          banners = false
        }
        return banners
      }
      return false
    },
    moduleTitle () {
      return {
        title: '购卡专区',
        text: ''
      }
    }
  },
  methods: {
    byCard (item) {
      // this.$utils.checkCanGoRouter('go_BuyCard')
      this.$utils.checkCanGoRouter(item.cardTargetUrl)
    }
  }
}
</script>

<style scoped lang="scss">

  .item {
    @extend .ljb-size100;
    overflow: hidden;
    display: flex;
    box-sizing: border-box;

  }

  .card-img {
    width: 128px;
    height: 85px;
    float: left;
  }

  .card-item {
    float: left;
    flex: 1;
    padding-left: 9px;
    height: 100%;
  }

  .card-price {
    /*margin-top: 6px;*/
    color: $price-color;
    font-size: 14px;
    /*font-weight: 600;*/
    font-weight: 600;
  }

  .text {
    max-lines: 2;
    max-width: 210px;
    height: 34px;
    font-size: 11px;
    @extend .ljb-md-hint-text;
    @extend .ljb-line-height20
  }

  .line {
    height: 0.5px;
    background-color: #eeeeee;
    margin-top: $padding;
    margin-left: 9px;
  }
  .card-title{
    font-size: 17px;
    align-items: center;
    align-content: center;
    @extend .ljb-line-height20;
    @extend .ljb-title;
    @extend .ljb-flex-row;
    @extend .ljb-flex-row;
  }
  .card-sp{
    padding-left: 9px;
    font-size: 11px;
    @extend .ljb-md-hint-text;
    text-decoration:line-through;
  }
  .card-tag{
    margin: auto 6px auto 0;
    /*height: 16px;*/
    padding: 0 4px;
    opacity: 0.8;
    font-family: "PingFangSC-Regular";
    background-color: $price-color;
    font-size: 10px;
    color: white;
    @extend .double-center
    /*line-height: 16px;*/
  }
  .item-margin-top{
    margin-top: $padding;
  }
  .base{
    padding-left: $padding;
    padding-right: $padding;
    box-sizing: border-box;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .btn{
    background-color: $base-color;
    height: 21px;
    width: 63px;
    color: white;
    font-size: 11px;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/ProductList.vue